import debounce from "lodash.debounce";
import searchImg from "../image/search.svg";
import { useDispatch } from "react-redux";
import { searchInput } from "../Redux/filter/action";

export default function Header() {
  // const setQuery = (text) => {
  //   console.log(text);
  // };
  const dispatch = useDispatch();

  const updateQuery = (e) => dispatch(searchInput(e?.target?.value));
  const debounced = debounce(updateQuery, 500);

  return (
    <div className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200">
      <input
        className="outline-none border-none bg-gray-50 h-full w-full mr-2"
        type="search"
        name="search"
        placeholder="Search"
        onChange={debounced}
      />
      <img className="inline h-6 cursor-pointer" src={searchImg} alt="Search" />
    </div>
  );
}
